// Old AreaOptionData (JASMINE/LOTUS) — preserved for reference
// export const AreaOptionData = {
//     "9": "9",
//     "12": "12",
//     // "16": "16",
//     "18": "18",
//     "24": "24",
//     "27": "27",
//     "36": "36",
//     "48": "48",
//     // "54": "54",
//     "60": "60",
//     "72": "72",
//     // "90": "90",
//     // "108": "108",
// }

export const AreaOptionData = {
    "9": "9",
    "12": "12",
    "16": "16",
    "18": "18",
    // "24": "24",
    "27": "27",
    "36": "36",
    // "48": "48",
    "54": "54",
    // "60": "60",
    "72": "72",
    // "90": "90",
    "108": "108",
}

export const HALL_KEYS_CONSTANT_DATA = {
    "Pavillion": "Pavillion",
    "JASMINE": "JASMINE",
    "LOTUS_HALL": "LOTUS_HALL",
    // "h1": "h1",
    "h2": "h2",
    "h3": "h3",
    "h4": "h4",
    "h5": "h5",
    "h6": "h6",
    "aurum": "aurum",
    // "h7": "h7",
}
export const HALL_CONSTANT_DATA = {
    // [HALL_KEYS_CONSTANT_DATA.Pavillion]: "Pavillion",
    // [HALL_KEYS_CONSTANT_DATA.h1]: "Hall 1 - BIEC",
    // [HALL_KEYS_CONSTANT_DATA.NESCO]: "NESCO",
    [HALL_KEYS_CONSTANT_DATA.h2]: "Hall 2 - BEC",
    [HALL_KEYS_CONSTANT_DATA.h3]: "Hall 3 - BEC",
    [HALL_KEYS_CONSTANT_DATA.h4]: "Hall 4 - BEC",
    [HALL_KEYS_CONSTANT_DATA.h5]: "Hall 5 - BEC",
    [HALL_KEYS_CONSTANT_DATA.h6]: "Hall 6 - BEC",
    [HALL_KEYS_CONSTANT_DATA.aurum]: "Aurum",
    // [HALL_KEYS_CONSTANT_DATA.h7]: "Hall 7 - BIEC",
    // [HALL_KEYS_CONSTANT_DATA.LOTUS_HALL]: "LOTUS_HALL",
    // [HALL_KEYS_CONSTANT_DATA.JASMINE]: "JASMINE",
}
// Old AREA_HALL_MAPPING (JASMINE/LOTUS) — preserved for reference
// export const AREA_HALL_MAPPING = {
//     // "6": [HALL_KEYS_CONSTANT_DATA.JASMINE,],
//     "9": [HALL_KEYS_CONSTANT_DATA.h2, HALL_KEYS_CONSTANT_DATA.h3, HALL_KEYS_CONSTANT_DATA.h4, HALL_KEYS_CONSTANT_DATA.h6],
//     "12": [HALL_KEYS_CONSTANT_DATA.h2, HALL_KEYS_CONSTANT_DATA.h3, HALL_KEYS_CONSTANT_DATA.h4, HALL_KEYS_CONSTANT_DATA.h6],
//     "16": [HALL_KEYS_CONSTANT_DATA.h2, HALL_KEYS_CONSTANT_DATA.h3, HALL_KEYS_CONSTANT_DATA.h4, HALL_KEYS_CONSTANT_DATA.h6],
//     "18": [HALL_KEYS_CONSTANT_DATA.h2, HALL_KEYS_CONSTANT_DATA.h3, HALL_KEYS_CONSTANT_DATA.h4, HALL_KEYS_CONSTANT_DATA.h6],
//     // "24": [HALL_KEYS_CONSTANT_DATA.JASMINE],
//     "27": [HALL_KEYS_CONSTANT_DATA.h2, HALL_KEYS_CONSTANT_DATA.h3, HALL_KEYS_CONSTANT_DATA.h4, HALL_KEYS_CONSTANT_DATA.h6],
//     "36": [HALL_KEYS_CONSTANT_DATA.h2, HALL_KEYS_CONSTANT_DATA.h3, HALL_KEYS_CONSTANT_DATA.h4, HALL_KEYS_CONSTANT_DATA.h6],
//     // "48": [HALL_KEYS_CONSTANT_DATA.JASMINE],
//     "54": [HALL_KEYS_CONSTANT_DATA.h2, HALL_KEYS_CONSTANT_DATA.h3, HALL_KEYS_CONSTANT_DATA.h4, HALL_KEYS_CONSTANT_DATA.h6],
//     // "60": [HALL_KEYS_CONSTANT_DATA.JASMINE],
//     "72": [HALL_KEYS_CONSTANT_DATA.h2, HALL_KEYS_CONSTANT_DATA.h3, HALL_KEYS_CONSTANT_DATA.h4, HALL_KEYS_CONSTANT_DATA.h6],
//     "108": [HALL_KEYS_CONSTANT_DATA.h2, HALL_KEYS_CONSTANT_DATA.h3, HALL_KEYS_CONSTANT_DATA.h4, HALL_KEYS_CONSTANT_DATA.h6],
// }

// Halls listed only where that area actually has stalls (from NESCO layout).
export const AREA_HALL_MAPPING = {
    // "6": [HALL_KEYS_CONSTANT_DATA.JASMINE,],
    "9": [HALL_KEYS_CONSTANT_DATA.h2, HALL_KEYS_CONSTANT_DATA.h3, HALL_KEYS_CONSTANT_DATA.h4, HALL_KEYS_CONSTANT_DATA.h6, HALL_KEYS_CONSTANT_DATA.h5, HALL_KEYS_CONSTANT_DATA.aurum],
    "12": [HALL_KEYS_CONSTANT_DATA.h2, HALL_KEYS_CONSTANT_DATA.h3, HALL_KEYS_CONSTANT_DATA.h4, HALL_KEYS_CONSTANT_DATA.h6],
    "16": [HALL_KEYS_CONSTANT_DATA.h2, HALL_KEYS_CONSTANT_DATA.h3, HALL_KEYS_CONSTANT_DATA.h4],
    "18": [HALL_KEYS_CONSTANT_DATA.h2, HALL_KEYS_CONSTANT_DATA.h3, HALL_KEYS_CONSTANT_DATA.h4, HALL_KEYS_CONSTANT_DATA.h6, HALL_KEYS_CONSTANT_DATA.h5, HALL_KEYS_CONSTANT_DATA.aurum],
    // "24": [HALL_KEYS_CONSTANT_DATA.JASMINE],
    "27": [HALL_KEYS_CONSTANT_DATA.h2, HALL_KEYS_CONSTANT_DATA.h3, HALL_KEYS_CONSTANT_DATA.h6, HALL_KEYS_CONSTANT_DATA.h5, HALL_KEYS_CONSTANT_DATA.aurum],
    "36": [HALL_KEYS_CONSTANT_DATA.h2, HALL_KEYS_CONSTANT_DATA.h3, HALL_KEYS_CONSTANT_DATA.h4, HALL_KEYS_CONSTANT_DATA.h6, HALL_KEYS_CONSTANT_DATA.h5],
    // "48": [HALL_KEYS_CONSTANT_DATA.JASMINE],
    "54": [HALL_KEYS_CONSTANT_DATA.h2, HALL_KEYS_CONSTANT_DATA.h3, HALL_KEYS_CONSTANT_DATA.h4, HALL_KEYS_CONSTANT_DATA.h6, HALL_KEYS_CONSTANT_DATA.aurum],
    // "60": [HALL_KEYS_CONSTANT_DATA.JASMINE],
    "72": [HALL_KEYS_CONSTANT_DATA.h2, HALL_KEYS_CONSTANT_DATA.h3, HALL_KEYS_CONSTANT_DATA.h4, HALL_KEYS_CONSTANT_DATA.h6, HALL_KEYS_CONSTANT_DATA.h5, HALL_KEYS_CONSTANT_DATA.aurum],
    "108": [HALL_KEYS_CONSTANT_DATA.h3, HALL_KEYS_CONSTANT_DATA.h4, HALL_KEYS_CONSTANT_DATA.h6],
}
